import { PlotReportFactElement } from '@/api/rest/resources/types/fact';

import { resolveThemeColor } from './resolveThemeColor';

export const getTrendIconColor = (value: number | undefined) => {
  if ((value as number) === 0) return null;
  if ((value as number) > 0) return resolveThemeColor('success');
  return resolveThemeColor('error');
};

export const getFactTrendIconColor = (fact: PlotReportFactElement | undefined) => {
  if (!fact) {
    return null;
  }
  return getTrendIconColor(fact.value as number);
};

export const getTrendTextColor = (value: number | undefined) => {
  if ((value as number) === 0) return resolveThemeColor('text-primary');
  if ((value as number) > 0) return resolveThemeColor('success-dark');
  return resolveThemeColor('error-dark');
};

export const getFactTrendTextColor = (fact: PlotReportFactElement | undefined) => {
  if (!fact) {
    return null;
  }
  return getTrendTextColor(fact.value as number);
};
